<script lang="ts">
    import {EmailAddress, Gender, General, MobileNo, Name} from "../../../utils/Constant/Constant";
    export let userItem
</script>
<div class="email-general">
    <h6 class="mb-3">{General}</h6>
    <ul>
        <li>{Name} <span class="font-primary first_name_0">{userItem.fname}</span></li>
        <li>{Gender} <span class="font-primary">{'Male'}</span></li>
        <li>{MobileNo}<span class="font-primary mobile_num_0">+0 {userItem.phone}</span></li>
        <li>{EmailAddress} <span class="font-primary email_add_0">{userItem.email} </span></li>
    </ul>
</div>